// extracted by mini-css-extract-plugin
export var bodyRow = "_eq-d";
export var cardColumns = "_eq-e";
export var ellipsesOverflow = "_eq-2";
export var flatBottomCorners = "_eq-3";
export var flatTopCorners = "_eq-4";
export var headerActionsDropdown = "_eq-f";
export var headerBottomRow = "_eq-c";
export var headerTopRow = "_eq-b";
export var orderDetailsWrapper = "_eq-0";
export var orderInfoContainer = "_eq-1";
export var productDetails = "_eq-9";
export var productImage = "_eq-5";
export var responsiveTable = "_eq-8";
export var shipmentContainer = "_eq-a";
export var tableBottomLeft = "_eq-6";
export var tableBottomRight = "_eq-7";